import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { Modal } from 'components/Blocks';

import { ChangeValueForm } from './ValueForm';
import { ConfirmationStep } from './ConfirmationStep';

import { FormControlHook, useFormControl } from 'hooks';

import { UploadedFile } from 'types/general';
import { quickContext } from 'utils/react';

interface PackageValueChangeState {
  understandStatement: string;
  confirmed: boolean;
  value: string;
  justification: string;
  proofFile: UploadedFile | null;
}

type PackageValueChangeStateContext = Pick<
  FormControlHook<PackageValueChangeState>,
  'state' | 'dispatch' | 'handleChange'
> & {
  open: () => void;
  close: () => void;
};

const { usePackageValueChange, withPackageValueChangeContext } = quickContext(
  'packageValueChange',
  () => {
    const { t } = useLang();

    const { state, dispatch, handleChange, resetDefault } = useFormControl({
      understandStatement: '',
      value: '',
      justification: '',
      proofFile: null as PackageValueChangeState['proofFile'],
      isOpen: false,
      confirmed: false,
    });

    return {
      data: useMemo(
        () =>
          ({
            state,
            dispatch,
            resetDefault,
            handleChange,

            open: () => dispatch({ isOpen: true }),

            close: resetDefault,
          }) as PackageValueChangeStateContext,
        [state, dispatch, handleChange, resetDefault],
      ),

      content: (
        <Modal
          close={resetDefault}
          isOpen={state.isOpen}
          allowEscape={false}
          title={t('change-package-value')!}
          width="min(40vw, 650px)"
        >
          {state.confirmed ? <ChangeValueForm /> : <ConfirmationStep />}
        </Modal>
      ),
    };
  },
);

export { usePackageValueChange, withPackageValueChangeContext };
